import React from 'react';
import PropTypes from 'prop-types';
import ConnectedCharts from './ConnectedCharts';

// TODO: Move to react-viewerbase

function ChartsRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedCharts />;
}

ChartsRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ChartsRouting;
